'use client';

import React from 'react';
import styles from './ServiceOverview.module.scss';

interface ServiceOverviewProps {
  title: string;
  description: string;
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
}

export function ServiceOverview({
  title,
  description,
  imageSrc,
  imageAlt,
  className
}: ServiceOverviewProps) {
  return (
    <section className={`${styles.overview} ${className || ''}`}>
      <div className={styles.overviewContent}>
        <h2 className={styles.overviewTitle}>{title}</h2>
        <p className={styles.overviewDescription}>{description}</p>
      </div>
      {imageSrc && (
        <div className={styles.overviewImage}>
          <img src={imageSrc} alt={imageAlt || title} />
        </div>
      )}
    </section>
  );
}

export default ServiceOverview;